module.exports = __webpack_public_path__ + "img/hundred-years-banner-bg.5410d2e.svg";